import _ from 'underscore';
import $ from 'jquery';

export default class OrderManage {
  constructor($scope, OrderService, PaginationService, UserService, DateService) {
    $scope.quick_search = function() {
      window.filter_table('table#orders', $scope.query);
    };

    $scope.update_website_stats = function() {
      $scope.updating_website_stats = true;
      OrderService.update_website_stats().then(function(data) {
        if (data.success) {
          $scope.updating_website_stats = false;
        }
      });
    };

    $scope.set_supplier_company_autocomplete = function(input) {
      input.autocomplete({
        delay: 300,
        source: function(request, response) {
          UserService.search_by_company('Seller', request.term).then(function(data) {
            response(data.users);
          });
        },
        select: function(event, ui) {
          $scope.filter.supplier_id = ui.item.id;
          $scope.$apply();
        }
      });
    };

    $scope.set_buyer_company_autocomplete = function(input) {
      input.autocomplete({
        delay: 300,
        source: function(request, response) {
          UserService.search_by_company('Buyer', request.term).then(function(data) {
            response(data.users);
          });
        },
        select: function(event, ui) {
          $scope.filter.buyer_id = ui.item.id;
          $scope.$apply();
        }
      });
    };

    $scope.get_orders = function() {
      $scope.searching = true;
      OrderService.get_manage_data($scope.filter).then(function(data) {
        $scope.orders = data.orders;
        $scope.pagination = PaginationService.get_pagination(data.pagination);
        $scope.searching = false;
      });
    };

    $scope.get_page_data = function(page) {
      $scope.filter.page = page;
      $scope.get_orders();
    };

    $scope.date_options = {
      changeMonth: true,
      changeYear: true,
      dateFormat: 'dd/mm/yy'
    };

    $scope.issued_columns = [
      {
        id: 'date_issued_pi',
        title: 'PI'
      },
      {
        id: 'date_issued_oc',
        title: 'OC'
      },
      {
        id: 'date_issued_commercial_invoice',
        title: 'CI'
      }
    ];

    $scope.get_status_title = function(status) {
      return _.find($scope.order_statuses, function(s) {
        return s.id == status;
      }).title;
    };

    $scope.get_payment_status_title = function(status) {
      return _.find($scope.payment_statuses, function(s) {
        return s.id == status;
      }).title;
    };

    $scope.get_delivery_status_title = function(status) {
      return _.find($scope.delivery_statuses, function(s) {
        return s.id == status;
      }).title;
    };

    $scope.get_need_attention = function() {
      $scope.init_filters();
      var now = new Date();
      var date_from = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 60);
      var date_to = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 21);
      $scope.filter.date_from = DateService.get_date_str(date_from);
      $scope.filter.date_to = DateService.get_date_str(date_to);
      $scope.filter.status = 0;
      $scope.filter.has_booking_notes = 'no';
      $scope.filter.sort_by = 0;
      $scope.get_orders();
    };

    $scope.get_recent_pi = function() {
      $scope.init_filters();
      var now = new Date();
      var date_from = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 60);
      $scope.filter.date_from = DateService.get_date_str(date_from);
      $scope.filter.date_to = DateService.get_date_str(now);
      $scope.filter.sort_by = 0;
      $scope.get_orders();
    };

    $scope.init_filters = function() {
      $scope.supplier_company = null;
      $scope.buyer_company = null;
      $scope.filter = {
        page: 1,
        per_page: 50,
        sort_by: null,
        sort_by_mode: 1,
        supplier_id: null,
        buyer_id: null,
        status: -1,
        delivery_status: -1,
        payment_status: -1,
        pi_id: null,
        oc_id: null,
        commercial_invoice: null,
        issued_column: 'date_issued_pi',
        date_from: null,
        date_to: null,
        has_stocklist: 'all',
        has_updated_pref: 'all',
        has_terms: 'all',
        has_booking_notes: 'all',
        buyer_country_id: null
      };
    };

    $scope.sort_by_modes = [
      {
        id: 0,
        title: 'ASC'
      },
      {
        id: 1,
        title: 'DESC'
      },
    ];

    $scope.init = function() {
      $scope.order_statuses = window.order_statuses;
      $scope.delivery_statuses = window.delivery_statuses;
      $scope.payment_statuses = window.payment_statuses;
      $scope.order_statuses.splice(0, 0, {
        id: -1,
        title: 'All'
      });
      $scope.delivery_statuses.splice(0, 0, {
        id: -1,
        title: 'All'
      });
      $scope.payment_statuses.splice(0, 0, {
        id: -1,
        title: 'All'
      });
      $scope.sort_by_options = window.sort_by_options;
      $scope.countries = window.countries;
      $scope.set_supplier_company_autocomplete($('input.supplier_company'));
      $scope.set_buyer_company_autocomplete($('input.buyer_company'));
      $scope.get_recent_pi();
    };

    $scope.init();
  }
}

OrderManage.$inject = ['$scope', 'OrderService', 'PaginationService', 'UserService', 'DateService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/order-manage.ctrl.js